import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'antd';
import styled from 'styled-components';
import PureModal from 'business/components/pureModal/index';
import { StyledButton as Button } from 'components/Styled';

const LOCAL_STORAGE_KEY = 'dismissTNC';

const getDismissState = () => {
  try {
    return !!localStorage.getItem(LOCAL_STORAGE_KEY);
  } catch (err) {
    return false;
  }
};

const saveDismissState = () => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
  } catch (err) {
    // ignore if fail to access local storage
    console.error(err);
  }
};

const TermsAndConditions = () => {
  const { t } = useTranslation();
  const isDismissed = getDismissState();
  const [isAccepted, setIsAccepted] = useState(isDismissed);
  const [dismiss, setDismiss] = useState(true);

  const handleConfirm = () => {
    if (dismiss) {
      saveDismissState();
    }

    window.dataLayer.push({
      event: 'Terms and conditions accepted'
    });
    setIsAccepted(true);
  };

  const handleChange = e => {
    const checked = e.target.checked;
    setDismiss(checked);
  };

  if (isAccepted) return null;

  return (
    <PureModal
      visible={true}
      closeable={false}
      maskClosable={false}
      bodyStyle={{ width: 400, height: 'auto' }}>
      <Body>
        <Card>
          <Container>
            <Heading>{t('TermsAndConditions.title')}</Heading>
            <Content>
              <h4>Prohibited Products</h4>
              <p>
                The following are the types of products that, for everyone’s
                safety, you are prohibited to ship through Spaceship. The items
                listed in this paragraph is not conclusive and you solely
                responsible for checking with the relevant laws, rules and
                regulations of the local and/or oversea custom and/or government
                authorities:
              </p>
              <ul>
                <li>
                  Any product related to illegal activities or which is
                  prohibited by law in the place of origin, the destination, or
                  any sites through which such product travel.
                </li>
                <li>
                  Any product requiring specific licenses to store or
                  distribute, import and export. Examples of products with
                  distribution and licensing requirements may include, but are
                  not limited to:
                  <ul>
                    <li>Live plants and animals;</li>
                    <li>Alcoholic beverages;</li>
                    <li>Ammunition &amp; firearms;</li>
                    <li>Tobacco;</li>
                    <li>Firearms and any kind of weapon;</li>
                    <li>
                      Prescription pharmaceuticals or other dangerous drugs;
                    </li>
                    <li>Explosive or hazardous products;</li>
                    <li>Unique or one-of-a-kind materials;</li>
                    <li>
                      Precious metals in the forms of bullion or reserves; and
                    </li>
                    <li>
                      Electronic component and/or device which subject to the
                      relevant laws and regulations
                    </li>
                  </ul>
                </li>
              </ul>
              <p>
                Spaceship shall not be liable for any delay, loss, damage,
                destruction caused by the Courier and/or confiscation by the
                local and/or oversea custom and government authorities of any
                prohibited product. Spaceship has the sole discretion to cancel
                any order if Spaceship is suspecting the user is sending the
                prohibited products.
              </p>
              <h4>Indemnification</h4>
              <p>
                You agree to fully indemnify and to hold harmless Spaceship, our
                officers, directors, employees and agents from and against any
                and all claims, liabilities, damages, losses or expenses,
                including but not limited to legal costs and disbursements due
                to or arising out of your use of the Services and/or your
                violation of the Terms of Service. Upon requesting for our
                Service, you agree to fully indemnify and hold harmless
                Spaceship from any and all claims for transportation, storage,
                handling and other charges relating to the goods in respect of
                the Shipment, including undercharges, rail demurrage,
                truck/intermodal detention and other charges of any nature, even
                though Spaceship and/or the Courier had accepted such order.
              </p>
            </Content>
            <Checkbox onChange={handleChange} checked={dismiss}>
              {t('TermsAndConditions.dontShowAgain')}
            </Checkbox>
            <Button onClick={handleConfirm} type="primary" block>
              {t('TermsAndConditions.buttonAgree')}
            </Button>
          </Container>
        </Card>
      </Body>
    </PureModal>
  );
};

const Body = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 90%;
  transform: translate(-50%, -50%);
  transition: 200ms ease-in;
  max-width: 400px;
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 4px;
  padding: 16px;
  font-size: 16px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 60vh;

  > *:not(:first-child) {
    margin-top: 1rem;
  }
`;

const Content = styled.div`
  flex-grow: 1;
  overflow-y: scroll;
  font-size: 14px;
`;

const Heading = styled.h3`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 0;
`;

export default TermsAndConditions;
